export default function SaveFiltersConfirmModalController(
	$scope,
	$rootScope,
	$uibModalInstance,
	savedFilter,
	gettextCatalog,
	savedFilterService
) {
	'ngInject';

	$scope.updating = false;
	$scope.errorFlag = false;
	$scope.errorText = '';
	$scope.savedFiltersModels = {};

	$scope.updateExistingFilter = function() {
		$scope.updating = true;
		savedFilterService
			.patchSavedFilter(savedFilter.id, savedFilter)
			.then(function() {
				return savedFilterService.getAllSavedFilters($rootScope.currentUser.id);
			})
			.then(function(response) {
				if (!response) {
					return;
				}

				$scope.savedFiltersModels = response.data.reverse();
				$scope.confirm();
			})
			.catch(function(error) {
				var errorMsg = gettextCatalog.getString(
					'An error occurred while retrieving Saved Filter information. Please try again later.'
				);
				if (error) {
					if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
						errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
					} else if (!!error.status && !!error.statusText) {
						errorMsg =
							gettextCatalog.getString('An error occurred while retrieving Saved Filter information:') +
							(error.status.toString() + ' - ' + error.statusText.toString());
					}
				}
				$scope.errorFlag = true;
				$scope.errorText = errorMsg;
			})
			.finally(function() {
				$scope.updating = false;
			});
	};

	$scope.confirm = function() {
		$uibModalInstance.close($scope.savedFiltersModels);
	};

	$scope.cancel = function() {
		$uibModalInstance.dismiss('cancel');
	};

	$scope.$on('$locationChangeStart', function(event) {
		event.preventDefault();
	});
}
